"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get get () {
        return get;
    },
    get getCaseInsensitive () {
        return getCaseInsensitive;
    }
});
const isPlainObject = (value)=>typeof value === "object" && value !== null && !Array.isArray(value);
const get = (path, nestedObj, notSetValue = undefined)=>{
    const keyPath = typeof path === "string" ? [
        path
    ] : path;
    // get a new keyPath with the last item removed
    const transformedList = keyPath.slice(0, keyPath.length - 1);
    // gets the object before the final key
    const shallowObj = transformedList.reduce((xs, x)=>isPlainObject(xs) && xs[x] ? xs[x] : {}, nestedObj);
    // set the return value to the notSetValue ( will overwrite later )
    let value = notSetValue;
    try {
        const lastKey = keyPath.slice(-1)[0];
        // at this point, we have the final object
        if (isPlainObject(shallowObj) && Object.prototype.hasOwnProperty.call(shallowObj, lastKey)) {
            value = shallowObj[lastKey];
        }
    } catch (err) {
        value = notSetValue;
    }
    return value;
};
const getCaseInsensitive = (path, nestedObj, notSetValue = undefined)=>{
    const keyPath = typeof path === "string" ? [
        path
    ] : path;
    // Create a key path array with each path string in lowercase
    const keyPathLowerCase = keyPath.map((value)=>value.toString()?.toLowerCase());
    // get a new keyPath with the last item removed
    const transformedList = keyPathLowerCase.slice(0, keyPathLowerCase.length - 1);
    // gets the object before the final key
    const shallowObj = transformedList.reduce((xs, x)=>{
        if (isPlainObject(xs)) {
            // converts keys of object at each level to lowercase for matching
            const objectLowerCase = Object.fromEntries(Object.entries(xs).map(([key, value])=>{
                if (typeof key === "string") {
                    return [
                        key.toLowerCase(),
                        value
                    ];
                } else {
                    return [
                        key,
                        value
                    ];
                }
            }));
            if (objectLowerCase[x]) {
                return objectLowerCase[x];
            }
        }
        return {};
    }, nestedObj);
    // Get the key at the final index of the lowercase key path
    const lastKey = keyPathLowerCase[keyPathLowerCase.length - 1];
    // Convert keys in inner object to lowercase for matching
    const shallowObjLowerCase = Object.fromEntries(Object.entries(shallowObj).map(([key, value])=>{
        if (typeof key === "string") {
            return [
                key.toLowerCase(),
                value
            ];
        } else {
            return [
                key,
                value
            ];
        }
    }));
    // If inner object is valid and a key matching lastKey is present, return that value
    if (isPlainObject(shallowObjLowerCase) && Object.prototype.hasOwnProperty.call(shallowObjLowerCase, lastKey)) {
        return shallowObjLowerCase[lastKey];
    }
    // Otherwise return not set value
    return notSetValue;
};
